
export enum TipoFechaAniversarioEnum {
    FECHA_ANIVERSARIO = 'FECHA_ANIVERSARIO',
    ANTEA_FECHA_ANIVERSARIO = 'ANTEA_FECHA_ANIVERSARIO',
    DESPUES_FECHA_ANIVERSARIO = 'DESPUES_FECHA_ANIVERSARIO'
}